<div class="period-box">
  <div class="category-wrapper">
    <div class="category-container category-container--povo">
      <div class="category category-povo">POVO</div>
      <button 
        class="range-button range-button--povo" 
        *ngFor="let block of withinRangeOfBlocks.povo" 
        [matTooltip]="block.coverText?.document[0].children?.[0].text"
        matTooltipPosition="right"
        matTooltipClass="range-tooltip range-tooltip--povo"
        (click)="scrollToBlock(block)"
      ></button>
    </div>
    <div class="category-container category-container--vo">
      <div class="category category-vo">VO</div>
      <button 
        class="range-button range-button--vo" 
        *ngFor="let block of withinRangeOfBlocks.vo" 
        [matTooltip]="block.coverText?.document[0].children?.[0].text"
        matTooltipPosition="right"
        matTooltipClass="range-tooltip range-tooltip--vo"
        (click)="scrollToBlock(block)"
      ></button>
    </div>
    <div class="category-container category-container--po">
      <div class="category category-po">PO</div>
      <button 
        class="range-button range-button--po" 
        *ngFor="let block of withinRangeOfBlocks.po" 
        [matTooltip]="block.coverText?.document[0]?.children?.[0].text"
        matTooltipPosition="right"
        matTooltipClass="range-tooltip range-tooltip--po"
        (click)="scrollToBlock(block)"
      ></button>
    </div>
  </div>
  <div class="period-wrapper">
    <div class="period" *ngFor="let period of periodIndexes; let i = index;" [ngClass]="activePeriod === (i + 1) ? 'number-' + (i + 1): ''" [ngStyle]="{'left': 10 + (20 * i) + 'px'}">
      <div *ngIf="i + 1 <= activePeriod">
        <div class="period-number" [ngStyle]="{'bottom': 150 - (20 * (i + 1)) + 1 + 'px'}" [class.active]="i + 1 === activePeriod">
          <p>{{ i + 1 }}</p>
        </div>
        <div class="period-line" [ngStyle]="{'height': 120 - (20 * (i + 1)) + 'px'}"></div>
        <div class="period-bullet"></div>
      </div>
    </div>
  </div>
</div>

<div class="scrollable" appHorizontalScroll #scrollable>
  <div class="wrapper">
    <app-timeline-day
      #timelineDay id="{{'day-' + days[0]}}"
      *ngFor="let days of filteredBlocksByDays; let i = index"
      [blocks]="days[1]"
      [activeIndex]="indexes[currentIndex] === days[0]"
      [period]="periodIndexes.indexOf(i) + 1"
    ></app-timeline-day>
  </div>
</div>

<div class="timeline">
  <div class="button-wrapper" *ngIf="!showBlockDetail">
    <div class="button" (click)="scrollToPreviousItem()" gtagEvent trackOn="click" action="previous_day_clicked" category="clicks" [params]="{ event_label: 'Vorige dag' }">
      <i class="fa-light fa-circle-arrow-left"></i>
      <p>Vorige dag</p>
    </div>
    <div class="button" (click)="scrollToNextItem()" gtagEvent trackOn="click" action="next_day_clicked" category="clicks" [params]="{ event_label: 'Volgende dag' }">
      <p>Volgende dag</p>
      <i class="fa-light fa-circle-arrow-right"></i>
    </div>
  </div>

  <div class="back-button" *ngIf="showBlockDetail" (click)="showTimeline()">
    <i class="fa-regular fa-arrow-up"></i>
    <p>Terug</p>
  </div>
</div>
